// extracted by mini-css-extract-plugin
export default {"docRow":"FriendCard_docRow__ZFjta","nameCell":"FriendCard_nameCell__sAlZO","emailCell":"FriendCard_emailCell__36I0E"};